import { useSearchParams } from 'react-router-dom';
import { AppTabs } from '../../components/ui/AppTabs';
import { AccountPage } from '../AccountPage';
import { PerfilHeader } from './ui';

export function AutenticacaoPage() {
  const [params, setParams] = useSearchParams();
  const aba = params.get('aba') || 'duas-etapas';
  return (
    <>
      <PerfilHeader title="Autenticação" description="Proteja sua conta com um segundo fator, chaves de acesso e uma senha forte." />
      <div className="mx-auto max-w-[860px] px-6 py-4">
        <AppTabs
          activeTabId={aba}
          onChange={(e) => setParams(e.detail.activeTabId === 'duas-etapas' ? {} : { aba: e.detail.activeTabId })}
          tabs={[
            { id: 'duas-etapas', label: 'Verificação em duas etapas', content: <AccountPage embedded section="mfa" /> },
            { id: 'senha', label: 'Senha', content: <AccountPage embedded section="senha" /> },
          ]}
        />
      </div>
    </>
  );
}

export default AutenticacaoPage;
